import { Link } from "react-router-dom";

import { Icon } from "../../../components/icons";
import { PRECIO_TEXTO, PRIMER_TORNEO_TEXTO, WHATSAPP_AUTO_LIVE } from "../content";
import { HeroScene } from "../mockups/HeroScene";
import "./OrgHero.css";

const HERO_CHIPS = [PRIMER_TORNEO_TEXTO, PRECIO_TEXTO, "Sin mensualidad"];

/** Encabezado de /organizador (#inicio): la promesa, el precio, la promoción
 * del primer torneo y «Pedir demo» a la vista sin bajar, también en celular. */
export function OrgHero() {
  return (
    <section id="inicio" className="t123-subhero--organizer t123-orghero" aria-labelledby="t123-orghero-title">
      <span className="t123-hero__dots" aria-hidden="true" />
      <div className="t123-shell t123-orghero__grid">
        <div className="t123-orghero__copy">
          <span className="t123-kicker">Para clubes, academias y organizadores</span>
          <h1 id="t123-orghero-title">
            Organiza tu torneo sin Excel <span>y sin perseguir pagos.</span>
          </h1>
          <p className="t123-orghero__lead">
            Tus jugadores se inscriben y pagan con Mercado Pago desde un solo enlace. Tú armas cuadros y grupos en un
            clic, acomodas tus canchas sin empalmes y ellos ven su horario en el celular, con recordatorio{WHATSAPP_AUTO_LIVE ? " por WhatsApp" : " antes de jugar"}.
            Para tenis, pádel y pickleball.
          </p>
          <div className="t123-orghero__actions">
            <a className="t123-btn t123-btn--primary t123-btn--arrow" href="#demo">
              Pedir demo
            </a>
            <a className="t123-btn t123-btn--outline" href="#como-funciona">
              Ver cómo funciona
            </a>
          </div>
          <ul className="t123-chip-row t123-orghero__chips">
            {HERO_CHIPS.map((chip) => (
              <li key={chip} className="t123-chip">
                <Icon name="check" strokeWidth={2.6} />
                <span>{chip}</span>
              </li>
            ))}
          </ul>
          <p className="t123-orghero__small">
            Tenis, pádel y pickleball <span aria-hidden="true">·</span> ¿Ya tienes cuenta?{" "}
            <Link to="/login">Inicia sesión</Link>
          </p>
        </div>
        <div className="t123-orghero__art">
          <HeroScene />
        </div>
      </div>
    </section>
  );
}
